import { ShippingAddress } from '../../../models/ShippingAddress';
import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetShippingAddressByOrderInput } from './GetShippingAddressByOrderInput';

export class GetShippingAddressByOrderService extends HttpServiceBase {

  handle = (input: GetShippingAddressByOrderInput): Promise<Result<ShippingAddress> | null> => {
    const promise = this.http.get<Result<ShippingAddress>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/shipping-address`);
    return promise;
  }
}
